import { finish, error } from '../../../modules/transactions/actions/query';
import api from '../../../api';

export function request(dispatch, { id, query }) {
    let q = {
        perPage: 200
    };

    // Date (placement / settlement)
    if (query.range) {
        let date = {
            gte: query.range.startDate,
            lte: query.range.endDate
        };

        if (query.type === 'finalization') {
            q.finalizedAt = date;
        } else {
            q.createdAt = date;
        }
    }

    // Account ID
    if (query.accountId) {
        q['wallet.id'] = {
            eq: parseFloat(query.accountId)
        };
    }

    // Type
    if (query.type) {
        q['type'] = {
            [typeof query.type === 'string' ? 'eq' : 'in']: query.type
        };
    }

    // Status
    if (query.status) {
        q['status'] = {
            [typeof query.status === 'string' ? 'eq' : 'in']: query.status
        };
    }

    // Amount
    if (query.amount && (query.amount.start || query.amount.end)) {
        q['operatorAmount'] = {};

        if (query.amount.start) {
            q['operatorAmount'].gte = parseFloat(query.amount.start);
        }

        if (query.amount.end) {
            q['operatorAmount'].lte = parseFloat(query.amount.end);
        }
    }

    // Payout
    if (query.payout && (query.payout.start || query.payout.end)) {
        q['operatorPayout'] = {};

        if (query.payout.start) {
            q['operatorPayout'].gte = parseFloat(query.payout.start);
        }

        if (query.payout.end) {
            q['operatorPayout'].lte = parseFloat(query.payout.end);
        }
    }

    // Translated as SQL orderBy instruction
    if ( query.sort ) {
        q[ 'sort' ] = query.sort;
    }

    api.post('/transactions', q, { cache: true }).then(
        (data) => {
            dispatch(finish(id, data.transactions, data.customers));
        },
        ({ errors }) => dispatch(error(id, errors))
    );
}
